import { Button } from '@shared/components/shadcn';
import { ArrowUp } from '@shared/icons';

type StaticBackToTopLinkProps = {
  label: string;
  href?: string;
  'data-testid'?: string;
};

/**
 * In-document jump link back to the page header.
 *
 * Intended as the optional footer of {@link StaticPageSection}. Defaults to
 * `#top`, which matches {@link StaticPageHeader}. Styled as a small secondary
 * button with an upwards arrow before the label. Renders a plain anchor: a
 * same-page hash jump needs no router, and `next/link` would request the route
 * from the server on every click.
 *
 * @param label - Visible link text
 * @param href - Hash target; defaults to `#top`
 */
function StaticBackToTopLink({ label, href = '#top', 'data-testid': dataTestId = 'static-back-to-top' }: StaticBackToTopLinkProps) {
  return (
    <Button asChild variant="secondary" size="s" className="gap-2 self-start" data-testid={dataTestId}>
      <a href={href}>
        <ArrowUp size="extra-small" />
        {label}
      </a>
    </Button>
  );
}

export { StaticBackToTopLink, type StaticBackToTopLinkProps };
